import __request__ from "routing/request";
export function createFilter(streamId, JSONbody, requestOptions) {
  return __request__("POST", `/streams/${streamId}/destinations/filters`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPaginatedFiltersForStream(streamId, query, page = 1, per_page = 50, sort, order = "asc", requestOptions) {
  return __request__("GET", `/streams/${streamId}/destinations/filters`, null, { "query": query, "page": page, "per_page": per_page, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateFilter(streamId, filterId, JSONbody, requestOptions) {
  return __request__("PUT", `/streams/${streamId}/destinations/filters/${filterId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteFilter(streamId, filterId, requestOptions) {
  return __request__("DELETE", `/streams/${streamId}/destinations/filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getFilter(streamId, filterId, requestOptions) {
  return __request__("GET", `/streams/${streamId}/destinations/filters/${filterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPaginatedFiltersForStreamAndTarget(streamId, targetId, query, page = 1, per_page = 50, sort, order = "asc", requestOptions) {
  return __request__("GET", `/streams/${streamId}/destinations/target/${targetId}/filters`, null, { "query": query, "page": page, "per_page": per_page, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
